require.config({
  baseUrl: '/',
  paths: {
    jquery: 'vendor/jquery/jquery.min',
    Cookie: 'vendor/jquery.coockie/jquery.cookie',
    bootstrap: 'vendor/bootstrap/js/bootstrap.min',
    flot: 'vendor/flot/jquery.flot',
    flot_navigate: 'vendor/flot/jquery.flot.navigate',
    flot_resize: 'vendor/flot/jquery.flot.resize',

    Helmsman: 'scripts/helmsman/Helmsman',
    Helmrunner: 'scripts/helmsman/Helmrunner',
    SisWebsocket: 'scripts/SisWebsocket'

  },
  shim: {
    jquery: {
      exports: 'jQuery'
    },

    bootstrap: {
      deps: ['jquery']
    },

    flot: {
      deps: ['jquery'],
      exports: 'plot'
    },

    flot_navigate: {
      deps: ['flot']
    },

    flot_resize: {
      deps: ['flot', 'jquery']
    }
  }
});

require(['SisWebsocket', 'Helmsman', 'Helmrunner', 'bootstrap'], function() {
	
});
